import * as api from "@/api/williams/scopesOfWork";
import { queryKeys } from "../../queryKeys";
import { ScopeOfWork } from "@/api/williams/scopesOfWork";
import { useMutation, useQueryClient } from "react-query";

export function useCancelScope() {
  const queryClient = useQueryClient();

  return useMutation(async (scope: ScopeOfWork) => {
    const data = await api.cancelScopeOfWork(scope);
    const updatedScope = {
      ...data,
      reportDate: data.reportDate.substring(0, 10),
    };

    queryClient.setQueryData(queryKeys.scopeOfWork.single(scope.id), updatedScope);
    queryClient.invalidateQueries(queryKeys.scopeOfWork.list());

    return updatedScope;
  });
}
